
import { AppService } from "app/services/app.service";
export abstract class AbMigracao extends AppService {
  abstract getDatasources();
  abstract migrar(body);
  abstract getLogs(idReferencia: number);
}